// Formata uma data "pura" (YYYY-MM-DD, sem hora nem fuso — ex.: presenca.data,
// matricula.data_inicio/data_fim, aluno.data_nascimento) pro formato BR.
//
// Extrai ano/mês/dia via regex, NUNCA via `new Date(string).toLocaleDateString()`:
// uma data "YYYY-MM-DD" é só ano/mês/dia, sem hora nem fuso, mas `new Date(...)`
// interpreta esse texto como meia-noite EM UTC, e toLocaleDateString()/getDate()/
// getMonth() leem de volta em horário LOCAL do navegador — pra qualquer fuso
// negativo (Brasil, UTC-3), isso volta pro dia anterior (meia-noite UTC de
// 14/09 = 21h LOCAL de 13/09), deslocando a data exibida em 1 dia. Mesmo
// cuidado já usado em AjusteGrade.js (calcularIdade/formatarDataBR locais).
export const formatarDataBR = (data) => {
  if (!data) return '-';
  const match = String(data).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '-';
  return `${match[3]}/${match[2]}/${match[1]}`;
};
